import { AvField, AvForm } from "availity-reactstrap-validation"
import { map } from "lodash"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, CardTitle, Col, Modal, ModalBody, Row } from "reactstrap"
import { createMember, getBranches, updateMember } from "store/actions"
import Select from "react-select"
import useRole, { getRoleOptions } from "hooks/useRole"
import { CountryCode } from "constants/countryValues"

const UserModal = ({ show, onCloseClick, updateData }) => {
  const dispatch = useDispatch()
  const { isSuperAdmin } = useRole()

  const [memberRole, setMemberRole] = useState("")
  const [branchType, setBranchType] = useState("branchStaff")
  const [branch, setBranch] = useState("Select Branch...")
  const [branchId, setBranchId] = useState("")
  const [branchSearch, setBranchSearch] = useState("")

  const defaultCountryCode = { label: "+91 (India)", value: "+91" }
  const [countryCode, setCountryCode] = useState(defaultCountryCode)

  const countryCodeOptions = CountryCode.map(c => ({
    label: `${c.code} (${c.name})`,
    value: c.code,
  }))

  useEffect(() => {
    if (isSuperAdmin()) {
      dispatch(getBranches(1, 10, branchSearch, "", ""))
    }
  }, [dispatch, branchSearch])

  const { branches, branchLoading, loading } = useSelector(state => ({
    branches: state.Branches.branches,
    branchLoading: state.Branches.loading,
    loading: state.Members.loading,
  }))

  const handleValidSubmit = (e, v) => {
    const memberData = {
      ...v,
      branch: branchId,

      role: updateData?.role ? updateData?.role : "member",
      isPrime: false,

      staffType: isSuperAdmin() ? branchType : "branchStaff",
      countryCode: countryCode?.value || "+91",
    }
    if (updateData?._id) {
      dispatch(updateMember(memberData, updateData?._id, onCloseClick))
    } else {
      dispatch(createMember(memberData, onCloseClick))
    }
  }

  useEffect(() => {
    setMemberRole(updateData?.user?.memberRole)

    if (updateData?.user?.countryCode) {
      const code = updateData.user.countryCode
      const match = CountryCode.find(c => c.code === code)
      setCountryCode(
        match
          ? { label: `${match.code} (${match.name})`, value: match.code }
          : defaultCountryCode
      )
    } else if (updateData?.countryCode) {
      const code = updateData.countryCode
      const match = CountryCode.find(c => c.code === code)
      setCountryCode(
        match
          ? { label: `${match.code} (${match.name})`, value: match.code }
          : defaultCountryCode
      )
    } else {
      setCountryCode(defaultCountryCode)
    }
  }, [updateData])

  const handleMemberRoleOptions = () => {
    if (branchType === "hqStaff") {
      return getRoleOptions("hq")
    } else {
      return getRoleOptions("member")
    }
  }
  useEffect(() => {
    if (updateData) {
      setBranch(updateData?.branch?.branch_name)
      setBranchId(updateData?.branch?._id)
    }
  }, [updateData, updateData])
  const branchOptions = [
    {
      options: branches?.branches?.map((result, index) => ({
        key: index,
        label: result?.branch_name,
        value: result._id,
      })),
    },
  ]
  const handleEnteredBranch = textEntered => {
    setBranchSearch(textEntered)
  }
  function handleFinalValuesBranch(event) {
    setBranch(event.label)
    setBranchId(event.value)
  }

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="p-4">
        <CardTitle>
          {updateData?._id ? "Edit Member" : "Add New Member"}
        </CardTitle>
        <AvForm
          onValidSubmit={(e, v) => {
            handleValidSubmit(e, v)
          }}
        >
          <Row>
            <>
              {isSuperAdmin() && (
                <div
                  className="btn-group mt-0 mt-xl-0 d-flex align-items-center justify-content-end"
                  role="group"
                  aria-label="Basic radio toggle button group"
                >
                  {map(
                    [
                      {
                        id: 22,
                        title: "Branch Staff",
                        value: "branchStaff",
                      },
                      {
                        id: 33,
                        title: "HQ Staff",
                        value: "hqStaff",
                      },
                    ],
                    (item, key) => (
                      <div key={key} className="ms-2">
                        <input
                          type="radio"
                          className="btn-check"
                          name="btnradio-staffType"
                          id={item.value + "staffType-create-update"}
                          autoComplete="off"
                          checked={branchType === item.value}
                          value={item.value}
                          onClick={e => {
                            const value = e.target.value
                            if (branchType?.includes(value) === true) {
                              setBranchType("")
                            } else {
                              setBranchType(value)
                            }
                          }}
                        />
                        <label
                          className="btn btn-sm btn-outline-info"
                          htmlFor={item.value + "staffType-create-update"}
                        >
                          {item.title}
                        </label>
                      </div>
                    )
                  )}
                </div>
              )}

              <Col className="col-12 mb-2">
                <AvField
                  name="name"
                  type="text"
                  label="Name"
                  placeholder="Name *"
                  value={updateData?.name}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "name is required",
                    },
                  }}
                />
              </Col>
              <Col className="col-12 mb-2 mt-1">
                <label>
                  Phone <span className="text-danger">*</span>
                </label>
                <div className="input-group" style={{ flexWrap: "nowrap" }}>
                  <div style={{ width: "160px", flexShrink: 0 }}>
                    <Select
                      value={countryCode}
                      onChange={setCountryCode}
                      options={countryCodeOptions}
                      classNamePrefix="select2-selection"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        control: base => ({
                          ...base,
                          minHeight: "38px",
                          borderRadius: "4px 0 0 4px",
                          borderRight: "none",
                        }),
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <AvField
                      name="phone"
                      type="number"
                      placeholder="Phone *"
                      value={updateData?.phone}
                      style={{ borderRadius: "0 4px 4px 0", height: "38px" }}
                      validate={{
                        required: {
                          value: true,
                          errorMessage: "phone is required",
                        },
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col className="col-12 mb-2">
                <AvField
                  name="email"
                  type="email"
                  label="E-mail"
                  placeholder="Email *"
                  value={updateData?.email}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "mail is required",
                    },
                  }}
                />
              </Col>
              {isSuperAdmin() && (
                <Col className=" mb-2 mt-2">
                  <label>Branch</label>
                  <Select
                    onInputChange={handleEnteredBranch}
                    value={branch}
                    placeholder={branch}
                    onChange={handleFinalValuesBranch}
                    options={branchOptions}
                    classNamePrefix="select2-selection"
                    isLoading={branchLoading}
                  />
                </Col>
              )}
            </>
          </Row>
          <Row>
            <div className="py-2">
              <Col className="col-12 mb-2">
                <AvField
                  name="memberRole"
                  type="select"
                  label="Designation"
                  value={updateData?.memberRole}
                  onChange={e => setMemberRole(e.target.value)}
                >
                  <option value="">Select role</option>
                  {handleMemberRoleOptions()?.map((item, key) => (
                    <option key={key} value={item?.value}>
                      {item?.label}
                    </option>
                  ))}
                </AvField>
              </Col>
            </div>
          </Row>

          <div className="d-flex justify-content-end align-items-center">
            <div className="text-center mt-3">
              <button
                type="button"
                className="btn btn-light ms-2"
                onClick={onCloseClick}
              >
                Cancel
              </button>
              <Button
                type="submit"
                className="btn ms-2"
                color="warning"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    {updateData?._id ? "Saving..." : "Creating..."}
                  </>
                ) : (
                  updateData?._id ? "Save" : "Create"
                )}
              </Button>
            </div>
          </div>
        </AvForm>
      </ModalBody>
    </Modal>
  )
}

UserModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
  updateData: PropTypes.any,
}

export default UserModal
